<script>
    export let bagSubtotal = 0;
    let deliveryFee = 10;
    let tax = parseFloat( deliveryFee * 0.18 ).toFixed(2);

    $: total = (parseFloat( bagSubtotal + deliveryFee ) + parseFloat( tax )).toFixed(2);
</script>

<style>
    .bag-summary{
        padding: 2rem 0 1.5rem 0;
        border-bottom: 1px solid #EEEEEE;
        font-size: 1.1rem;
        color: #666666;
    }
    .bag-summary>div{
        width: 100%;
        margin-bottom: 1rem;
        text-align: right;
    }
    .bag-summary>div>div{
        display: inline-block;
    }
    .bag-summary>div>div:nth-child(2){
        min-width: 7rem;
        padding-left: 1rem;
        text-align: left;
    }
    .total, .payment{
        color: #333333;
        font-weight: 500;
    }
</style>

<div class="bag-summary">
    <div>
        <div>Subtotal (5 items)</div>
        <div>₹{bagSubtotal}</div>
    </div>

    <div>
        <div>Delivery fee</div>
        <div>₹{deliveryFee}</div>
    </div>

    <div>
        <div>GST</div>
        <div>₹{tax}</div>
    </div>

    <div>
        <div>Total</div>
        <div class="total">₹{total}</div>
    </div>

    <div>
        <div>Payment</div>
        <div class="payment">Cash</div>
    </div>
</div>
